import { InventryLocation } from "@dana/Handlers/ProductAvailabilityHandler";
import { SelectedInventryLocationsActions } from "@dana/Store/Data/ProductAvailability/Reducers/SelectedInventryLocationsReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";


export interface SelectedInventryLocationsParameter {
    selectedLocations: InventryLocation[];
    productId: string;
}


type HandlerType = Handler<{},
    DispatchProp<SelectedInventryLocationsActions>>;


export const ResetLocations: HandlerType = props => {
    props.dispatch({
        type: "SelectedInventryLocations/ResetLocations"
    });
}

export const chain = [
    ResetLocations

];

const resetSelectedInventryLocations = createHandlerChainRunner(chain, "ResetSelectedInventryLocationsHandler");
export default resetSelectedInventryLocations;
